module.exports = __webpack_public_path__ + "img/fondo-banner-principal.a05dad5b.png";